'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;
exports.getSubject = getSubject;
var GET_SUBJECT = 'bp/cu/subject/GET_SUBJECT';
var GET_SUBJECT_SUCCESS = 'bp/cu/subject/GET_SUBJECT_SUCCESS';
var GET_SUBJECT_FAIL = 'bp/cu/subject/GET_SUBJECT_FAIL';

var initialState = {
    subjects: [],
    loading: true,
    cuHashId: "",
    year: ""
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case GET_SUBJECT:
            return _extends({}, state, {
                subjects: [],
                loading: true
            });
        case GET_SUBJECT_SUCCESS:
            if (!action.result.data.success) {
                return state;
            }
            return _extends({}, state, {
                subjects: action.result.data.data,
                loading: false,
                cuHashId: action.cuHashId,
                year: action.year
            });
        default:
            return state;
    }
}

function getSubject(cuHashId, year) {
    return {
        types: [GET_SUBJECT, GET_SUBJECT_SUCCESS, GET_SUBJECT_FAIL],
        promise: function () {
            function promise(client) {
                return client.get('/api/cu_school/subject_majors?schoolHashId=' + cuHashId + '&year=' + year);
            }

            return promise;
        }(),
        cuHashId: cuHashId,
        year: year
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/reducers/cu/cuSubject.js
// module id = 460
// module chunks = 0